import type { EventDetails, EventDetailsRequest } from "./types"

import { getResultFromResponse } from "@/modules/apiRequests/handlers"
import { EVENT_DETAILS_PATH } from "@/modules/eventDetails/client/constants/api"
import { handleFetchError } from "@/modules/fetch/errorHandler"
import { fetcher } from "@/modules/fetch/fetcher"
import { toCamelCaseKeys } from "@/modules/format/object/toCamelCaseKeys"

export const getEventDetails = async (params: EventDetailsRequest): Promise<EventDetails> => {
  const { locale, hostname, slug, nextRequest } = params

  return fetcher(`/${locale}${EVENT_DETAILS_PATH}${slug}`, { hostname, nextRequest, serviceDomain: "MONOLITH_API" })
    .then(getResultFromResponse<EventDetails>({ transformResult: toCamelCaseKeys<EventDetails> }))
    .catch(handleFetchError(`${EVENT_DETAILS_PATH}${slug}`))
}
